import React from "react";
import { MESSAGING_ENABLED } from "../../config/messagingEnabled";

let MessageUserButtonImpl = null;

if (MESSAGING_ENABLED) {
    MessageUserButtonImpl = require("./MessageUserButton").default;
}

export default function MessageUserButtonGate({ user }) {
    if (!MESSAGING_ENABLED || !MessageUserButtonImpl) {
        return null;
    }
    return <MessageUserButtonImpl user={user} />;
}
